module.exports = __webpack_public_path__ + "media/images/download/e-book12-54f143f985a237cb60c312bf578f7786.png";